export default {
  container: {
    flexDirection: 'column',
  },
  title: {
    mx: 0,
  },
  listP: {
    m: 0,
    fontSize: ['18px', '16px', '16px', '18px', '18px'],
    lineHeight: 1.8,
    color: '#475467',
    whiteSpace: 'pre-line',
  },
  listSpan: {
    fontWeight: 600,
    color: 'gray900',
    display: 'inline-block',
  },
  link: {
    textDecoration: 'none',
    color: '#0086C9',
  },
  imageContainer: {
    left: '50%',
    transform: 'translateX(-50%)',
    my: '20px',
  },
};
